import { render, staticRenderFns } from "./factors-comp.vue?vue&type=template&id=42087f1a&scoped=true&"
import script from "./factors-comp.vue?vue&type=script&lang=js&"
export * from "./factors-comp.vue?vue&type=script&lang=js&"
import style0 from "./factors-comp.vue?vue&type=style&index=0&id=42087f1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42087f1a",
  null
  
)

export default component.exports